---
title: Presentazione Progetto 2024
published_time: 2024-09-06T14:30:00Z
og:
  title: "Gravity Play: Trasforma l'Acqua in Energia con Last1372"
  description: Unisciti al progetto Gravity Play di Last1372, approvato da Meet and Code! Scopri come convertire l'acqua in movimento in energia elettrica attraverso un percorso formativo gratuito per ragazzi dai 14 anni. Iscriviti ora e gioca con l'energia gravitazionale!
---

![lab](logo)

L’associazione Last1372 presenta il suo progetto **Gravity Play**, approvato da [Meet and Code](https://www.meet-and-code.org/). L’iniziativa formativa ha come obiettivo la conversione in energia elettrica, goccia su goccia, dell’acqua in movimento giocando con l’energia gravitazionale idrica a basso potenziale presente in tutte le case o acqua piovana.
L’acqua come elemento prezioso per la vita non può essere sprecata, anche una goccia può essere importante.

![Meet and Code](meet-and-code)

Sarà un gioco produrre energia elettrica, accumularla in una batteria o super condensatore o per produrre idrogeno.
Il percorso formativo proposto si svolgerà in ambiente scolastico nella prima settimana di ottobre, è gratis, è rivolto a coloro che hanno compiuto 14 anni.

All’atto d’iscrizione, all’indirizzo xymente@gmail.com, devono essere forniti nome, cognome e classe di appartenenza per l’anno scolastico 2024, dati che saranno comunicati al Dirigente Scolastico.

[Vedi su Facebook](https://www.facebook.com/groups/1710139465896520/permalink/3863699610540484/?rdid=2CkquvJ877MPZhzD&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2Fp%2FM9kgducxYK7xpgDh%2F)
